/**
 * Route for `on-the-go-campaign-monitoring-in-mobile-app`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { OnTheGoCampaignMonitoringInMobileAppPage } from "../features/on-the-go-campaign-monitoring-in-mobile-app/OnTheGoCampaignMonitoringInMobileAppPage";

export const onTheGoCampaignMonitoringInMobileAppRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/on-the-go-campaign-monitoring-in-mobile-app",
	component: OnTheGoCampaignMonitoringInMobileAppPage,
});

export default onTheGoCampaignMonitoringInMobileAppRoute;
